import { mutationOptions, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { queryKeys as sessionQueryKeys } from '@/entities/session';

import { transcriptApi } from './transcript.api';
import { queryKeys } from './transcript.queries';

export function useDeleteTranscriptOptions(transcriptId: string) {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: () => transcriptApi.delete(transcriptId),
        onMutate: async () => {
            await queryClient.cancelQueries({ queryKey: queryKeys.transcript(transcriptId) });
        },
        onSuccess: async () => {
            queryClient.setQueryData(queryKeys.transcript(transcriptId), null);
            queryClient.setQueryData(queryKeys.metadata(transcriptId), null);
            queryClient.setQueryData(
                sessionQueryKeys.detail(transcriptId),
                (data) =>
                    data && {
                        ...data,
                        isTranscriptAutoDeleted: false,
                        transcriptDeletedAt: new Date().toISOString(),
                    },
            );
        },
        onError: (error) => {
            console.error('Failed to delete transcript:', error);
            toast.error('Failed to delete transcript');
        },
    });
}
